import { modulesAdapter, getSurveysAdapter } from '@/module/adapters';

export default class QueriesController {
  #api;
  #paths;
  constructor(requestService, paths) {
    this.#api = requestService;
    this.#paths = paths;
  }

  async fetchModuleSkills() {
    const path = this.#paths.learnSkills.skills;
    const { data } = await this.#api.Get(path);
    return modulesAdapter(data);
  }

  async fetchModules({ childId }) {
    const path = this.#paths.activeModules.modules(childId);
    const { data } = await this.#api.Get(path);
    return modulesAdapter(data);
  }

  async fecthSkillLessons({ id }) {
    const path = this.#paths.learnSkills.lessonBySkillId(id);
    const { data } = await this.#api.Get(path);
    return data;
  }

  async fecthLessonDetail(lessonId) {
    const path = this.#paths.learnSkills.lessonDetail(lessonId);
    const { data } = await this.#api.Get(path);
    return data;
  }

  async fetchClasses({ childId }) {
    const path = this.#paths.manageClasses.classes(childId);
    const { data } = await this.#api.Get(path);
    return data;
  }

  async fetchSurveys() {
    try {
      const path = this.#paths.surveys.getSurveys;
      const { data } = await this.#api.Get(path);
      return getSurveysAdapter(data);
    } catch (error) {
      throw new Error('[Query]: Sorry, Unable to obtain the surveys.');
    }
  }
}
